module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rangeIvvi"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": require("../images/banner.png"),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("免费WiFi用户安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("免费WiFi用户安全理赔计划是指免费WiFi用户在使用免费WiFi连接网络的过程中，因在通过免费WiFi连接的热点网络环境下发生了服务协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每人单次可理赔金额10000元"), _c('br'), _vm._v("每人最高可理赔金额高达100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.用户必须是免费WiFi的手机注册用户，且其安装并使用的免费WiFi手机客户端中必须已发布施行了本保险计划（即用户必须安装安卓版免费WiFi 4.1.8版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.向免费WiFi提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3905836"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rangeIvvi.vue
// module id = 845
// module chunks = 1